import { Directive, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[appEnterKeyListener]' // this must match the name in the template
})
export class EnterKeyListenerDirective {
  @Input('appEnterKeyListener') field!: 'start' | 'end' | 'phone';

  @HostListener('onSelect', ['$event'])
  onEnterPressed(_event: KeyboardEvent) {
    const inputId =
      this.field === 'start'
        ? 'startDateInput'
        : this.field === 'end'
          ? 'endDateInput'
          : this.field === 'phone'
           ? 'phoneInput'
            : null;

    if (inputId) {
      const inputEl = document.getElementById(inputId);
      inputEl?.focus();
    }
  }
}